import React, { useState, useEffect } from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import styled from "styled-components";

export const monthlist = [
  { id: 1, month: "Jan" },
  { id: 2, month: "Feb" },
  { id: 3, month: "Mar" },
  { id: 4, month: "Apr" },
  { id: 5, month: "May" },
  { id: 6, month: "Jun" },
  { id: 7, month: "Jul" },
  { id: 8, month: "Aug" },
  { id: 9, month: "Sep" },
  { id: 10, month: "Oct" },
  { id: 11, month: "Nov" },
  { id: 12, month: "Dec" },
];

const CustomTextField = styled(TextField)(({ theme, error, width }) => ({
  "& .MuiInputBase-root": {
    height: "2rem",
    backgroundColor: "#fff",
  },
  ...(error && {
    "& .MuiOutlinedInput-root": {
      borderColor: "#D34040",
      "&:hover": {
        borderColor: "#D34040",
      },
      "&.Mui-focused": {
        borderColor: "#D34040",
      },
    },
  }),
  width: width || "auto", // Apply fixed width if provided
}));

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "35%",
      overflowY: "auto",
    },
  },
};

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
const startYear = 2013; // Earliest supported reporting year
const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i); // Full supported range through the current year

const MonthYearPicker = ({
  name,
  title,
  errors,
  setErrors,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
  defaultMonth = currentMonth+1,
  defaultYear = currentYear,
  gap,
}) => {
  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");

  useEffect(() => {
    setSelectedMonth(defaultMonth);
    setSelectedYear(defaultYear);
  }, [defaultMonth, defaultYear]);

  // Handle Month and Year Change
  const handleMonthChange = (event) => {
    setDisableValue("");
    setErrors && setErrors({ ...errors, month: "" });
    const selectedMonthIndex = event.target.value;
    console.log("month", monthlist[selectedMonthIndex], selectedMonthIndex, currentMonth + 1);
    setSelectedMonth(selectedMonthIndex);
  };

  const handleYearChange = (event) => {
    setErrors && setErrors({ ...errors, year: "" });
    setSelectedYear(event.target.value);
  };

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: gap || 1, height: "1rem" }}>
        {/* Month Input with Fixed Width */}
        <CustomTextField
          select
          name={name}
          value={selectedMonth || "Tap to select"}
          onChange={handleMonthChange}
          error={!!errors}
          width={"5rem"} // Set fixed width for Month field
          SelectProps={{ MenuProps }}
        >
          <MenuItem value="Tap to select" disabled>
            {"Month"}
          </MenuItem>
          {monthlist.map((option, index) => (
            <MenuItem key={option?.id} value={option?.id}>
              {option?.month} {/* Render the option's name */}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors?.month && (
          <Typography variant="body2" color="#D34040">
            {errors?.month}
          </Typography>
        )}

        {/* Year Input with Fixed Width */}
        <CustomTextField
          select
          name={name}
          value={selectedYear || "Tap to select"}
          onChange={handleYearChange}
          error={!!errors}
          width={"6rem"} // Set fixed width for Year field
          SelectProps={{ MenuProps }}
        >
          <MenuItem value="Tap to select" disabled>
            {"Year"}
          </MenuItem>
          {filteredYears.map((option, index) => (
            <MenuItem key={option} value={option}>
              {option} {/* Render the option's name */}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors?.year && (
          <Typography variant="body2" color="#D34040">
            {errors?.year}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MonthYearPicker;
